<key-form-builder [form]="form"
    [values]="values"
    autoTranslatePrefix="ANALYTICS.SETTINGS"
    (onChange)="changeFormSetting($event)">
</key-form-builder>